/* tslint:disable */

declare var Object: any;
export interface TaxesInterface {
  "income_key": string;
  "state": string;
  "taxes": Array<any>;
  "id"?: any;
}

export class Taxes implements TaxesInterface {
  "income_key": string;
  "state": string;
  "taxes": Array<any>;
  "id": any;
  constructor(data?: TaxesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Taxes`.
   */
  public static getModelName() {
    return "Taxes";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Taxes for dynamic purposes.
  **/
  public static factory(data: TaxesInterface): Taxes{
    return new Taxes(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Taxes',
      plural: 'Taxes',
      properties: {
        "income_key": {
          name: 'income_key',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "taxes": {
          name: 'taxes',
          type: 'Array&lt;any&gt;'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Taxes.ts